import { combineReducers } from 'redux'
import {leftSidebar, layout, locale, formDebug, intervalChanges} from './settings/reducer'
import toaster from './toaster/reducer'
import leftMenu from './leftMenu/reducer'
import auth from './auth/reducer'
import info from './info/reducer'
import infoLogin from './info-login/reducer'
import item from './item/reducer'
import dataStructures from './dataStructures/reducer'
import strings from './strings/reducer'
import adminStrings from './adminStrings/reducer'
import filters from './filters/reducer'
import users from './users/reducer'
import faq from './faq/reducer'
import enums from './enums/reducer'
import lazyLoad from './lazyLoad/reducer'
import calculations from './calculations/reducer'
import calculation from './calculation/reducer'
import settingsCompanies from './settingsCompanies/reducer'
import settingsEmails from './settingsEmails/reducer'
import settingsCredentials from './settingsCredentials/reducer'
import settingsZzjs from './settingsZzjs/reducer'
import usersRoles from './usersRoles/reducer'
import hints from './hints/reducer'
import userUcredentials from './userUcredentials/reducer'
import settingsProducts from './settingsProducts/reducer'
import settingsProductcests from './settingsProductcests/reducer'
import settingsProductmajs from './settingsProductmajs/reducer'
import settingsProductodps from './settingsProductodps/reducer'
import settingsPredefcombs from './settingsPredefcombs/reducer'
import settingsEnums from './settingsEnums/reducer'
import settingsExtccars from './settingsExtccars/reducer'
import settingsExtcalcmajs from './settingsExtcalcmajs/reducer'
import settingsAddinfos from './settingsAddinfos/reducer'
import settingsCarmodels from './settingsCarmodels/reducer'
import settingsCarmodelosts from './settingsCarmodelosts/reducer'
import contracts from './contracts/reducer'
import settingsMenuFiles from './settingsMenuFiles/reducer'
import settingsGlobalMenuFiles from './settingsGlobalMenuFiles/reducer'
import settingsZzjSnippets from './settingsZzjSnippets/reducer'
/*modules_here1*/

export default combineReducers({
    toaster,
    leftMenu,
    leftSidebar,
    layout,
    locale,
    formDebug,
    intervalChanges,
    auth,
    info,
    infoLogin,
    item,
    dataStructures,
    strings,
    adminStrings,
    filters,
    users,
    faq,
    enums,
    lazyLoad,
    calculations,
    calculation,
    settingsCompanies,
    settingsEmails,
    settingsCredentials,
    settingsZzjs,
    usersRoles,
    hints,
  userUcredentials,
  settingsProducts,
  settingsProductcests,
  settingsProductmajs,
  settingsProductodps,
  settingsPredefcombs,
  settingsEnums,
  settingsExtccars,
  settingsExtcalcmajs,
  settingsAddinfos,
  settingsCarmodels,
  settingsCarmodelosts,
  contracts,
  settingsMenuFiles,
  settingsGlobalMenuFiles,
  settingsZzjSnippets,
/*modules_here2*/
})